import { useCallback } from 'react';
import { FieldExtensionComponentProps } from '@backstage/plugin-scaffolder-react';
import { CondorDefaultsEditor } from 'config-editor';
import { CONDOR_DEFAULT_LAMBDA_RUNTIME } from 'config-editor-common';
import type { CondorLambdaDefaults } from 'config-editor-common';
import { useObjectField } from '../fieldState';

type Props = FieldExtensionComponentProps<CondorLambdaDefaults>;

export function CondorLambdaDefaultsEditor(props: Props) {
  const fallback = useCallback(
    (): CondorLambdaDefaults => ({
      timeout: 24,
      memory_size: 1024,
      runtime: CONDOR_DEFAULT_LAMBDA_RUNTIME,
      layer_names: [],
    }),
    [],
  );

  // Condor keeps the per-lambda fields out of the shared defaults block.
  const sanitize = useCallback((parsed: CondorLambdaDefaults) => {
    const rest = { ...(parsed as Record<string, unknown>) };
    delete rest.lambda_source;
    delete rest.s3_key;
    delete rest.build_number;
    delete rest.env_vars;
    return rest as CondorLambdaDefaults;
  }, []);

  const { value, commit } = useObjectField(props, { fallback, sanitize });

  return <CondorDefaultsEditor defaults={value} onChange={commit} />;
}
